export default "__VITE_ASSET__Xb8Y5bWw__"